import React from "react";
import ShopSettings from "../../components/Shop/ShopSettings";

const ProfileShopSettings = () => {
  return <ShopSettings />;
};

export default ProfileShopSettings;

